/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cashflow_OutflowInputs */

const vi_cashflow_outflow = /** @type {(inputs: Cashflow_OutflowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiền ra`)
};

/**

* @param {Cashflow_OutflowInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const cashflow_outflow = /** @type {((inputs?: Cashflow_OutflowInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cashflow_OutflowInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cashflow_outflow(inputs)
});